import Foundation from 'foundation-sites';
import Swiper, {
	Navigation,
	Pagination,
	Keyboard,
	Scrollbar,
	Lazy,
	HashNavigation,
	Autoplay,
	EffectFade,
	Thumbs,
} from 'swiper';
import Masonry from 'masonry-layout';
import Muuri from 'muuri';
import Plyr from 'plyr';
import $ from 'jquery';
window.$ = $;

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Keyboard, Scrollbar, Lazy, Autoplay, EffectFade, Thumbs]);

// Configuration
const illuScrollSpeed = 20000;

// Make top illustration scrollable on touch devices
function makeIlluScrollable(elt) {
	const slider = document.querySelector(elt);
	if (!slider) {
		return;
	}
	let isDown = false;
	let startX;
	let scrollLeft;
	slider.addEventListener('touchstart', (e) => {
		$(elt).stop();
		isDown = true;
		startX = e.touches[0].pageX - slider.offsetLeft;
		scrollLeft = slider.scrollLeft;
	});
	slider.addEventListener('touchend', () => {
		makeIlluAutoScroll(elt, true);
		isDown = false;
	});
	slider.addEventListener('touchmove', (e) => {
		if (!isDown) return;
		e.preventDefault();
		const x = e.touches[0].pageX - slider.offsetLeft;
		const walk = x - startX;
		slider.scrollLeft = scrollLeft - walk;
	});
	slider.addEventListener('mousedown', (e) => {
		$(elt).stop();
		isDown = true;
		startX = e.pageX - slider.offsetLeft;
		scrollLeft = slider.scrollLeft;
	});
	slider.addEventListener('mouseleave', () => {
		isDown = false;
	});
	slider.addEventListener('mouseup', () => {
		makeIlluAutoScroll(elt, true);
		isDown = false;
	});
	slider.addEventListener('mousemove', (e) => {
		if (!isDown) return;
		e.preventDefault();
		const x = e.pageX - slider.offsetLeft;
		const walk = (x - startX) * 3; //scroll-fast
		slider.scrollLeft = scrollLeft - walk;
	});
}

function makeIlluAutoScroll(elt, fwd) {
	$(elt).animate(
		{
			scrollLeft: fwd ? $(elt).find('img, video').width() - $(window).width() : 0,
		},
		{
			duration: illuScrollSpeed,
			easing: 'swing',
			complete: function () {
				makeIlluAutoScroll(elt, !fwd);
			},
		}
	);
}

// Start Foundation
$(document).foundation();

// Init. special page elements
$(document).ready(function ($) {
	// Make external links open new tab
	$(
		'a:not([href^="#"]):not([href*="' +
			window.location.hostname +
			'"]):not([href*="blog.' +
			window.location.hostname.replace(/^(www|blog)\./, '') +
			'"])'
	).attr('target', '_blank');
	$('a[href*="' + window.location.hostname.replace(/^(www|blog)\./, '') + '"]:not(.blank)').attr('target', '');

	// Set Logo URL to home site
	$('header .logo')
		.parent('a')
		.attr('href', 'https://www.' + window.location.hostname.replace(/^(www|blog)\./, ''));

	// Initialize all swipers
	var swiperFacts = new Swiper('.acf-block-swiper-facts .swiper-container', {
		loop: true,
		slidesPerView: 'auto',
		centeredSlides: true,
		spaceBetween: 30,
		grabCursor: true,
		draggable: true,
		pagination: {
			el: '.swiper-pagination',
			type: 'fraction',
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		speed: 1400,
		autoplay: {
			delay: 4000,
			disableOnInteraction: true,
		},
	});
	$('.acf-block-swiper-gallery .swiper-container').each(function () {
		new Swiper(this, {
			pagination: {
				el: '.swiper-pagination',
				type: 'fraction',
			},
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			spaceBetween: 0,
			autoplay: {
				delay: 2500,
				disableOnInteraction: true,
			},
		});
	});

	$('.acf-block-testimonial .swiper-container').each(function () {
		new Swiper(this, {
			loop: true,
			centeredSlides: false,
			spaceBetween: 30,
			pagination: {
				el: $(this).find('.swiper-pagination'),
				clickable: true,
			},
			speed: 1400,
			autoplay: {
				delay: 4000,
				disableOnInteraction: true,
			},
			grabCursor: true,
			draggable: true,
			slidesPerView: 1,
			spaceBetween: 30,
			// init: false,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			breakpoints: {
				640: {
					slidesPerView: 1,
					spaceBetween: 30,
				},
				768: {
					slidesPerView: 2,
					spaceBetween: 30,
				},
				1024: {
					slidesPerView: 2,
					spaceBetween: 30,
				},
			},
		});
	});

	var TentyYearsNewsSwiper = new Swiper('.twenty-years-news-swiper', {
		loop: true,
		slidesPerView: 'auto',
		centeredSlides: true,
		spaceBetween: 0,
		grabCursor: true,
		draggable: true,
		pagination: {
			el: '.swiper-pagination',
			type: 'fraction',
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		speed: 1400,
		autoplay: {
			delay: 4000,
			disableOnInteraction: true,
		},
	});

	var TentyYearsVIPSwiper = new Swiper('.twenty-years-vip-swiper', {
		loop: true,
		slidesPerView: 'auto',
		centeredSlides: true,
		spaceBetween: 0,
		grabCursor: true,
		draggable: true,
		pagination: {
			el: '.swiper-pagination',
			type: 'fraction',
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		speed: 1400,
		autoplay: {
			delay: 4000,
			disableOnInteraction: true,
		},
		autoplay: false,
	});

	window.vipSwiper = TentyYearsVIPSwiper;

	var TentyYearsRelatedSwiper = new Swiper('.twenty-years-related-articles-swiper', {
		loop: true,
		slidesPerView: 1,
		centeredSlides: true,
		spaceBetween: 15,
		grabCursor: true,
		draggable: true,
		pagination: {
			el: '.swiper-pagination',
			type: 'fraction',
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		speed: 1400,
		autoplay: {
			delay: 4000,
			disableOnInteraction: true,
		},
		breakpoints: {
			640: {
				slidesPerView: 1,
				spaceBetween: 30,
			},
			768: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
		},
	});

	var swiper = new Swiper('.custom-teasers-swiper', {
		slidesPerView: 1,
		spaceBetween: 0,
		loop: true,
		grabCursor: true,
		draggable: true,
		// init: false,

		pagination: {
			el: '.swiper-pagination',
			type: 'fraction',
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		breakpoints: {
			640: {
				slidesPerView: 2,
				spaceBetween: 0,
			},
			768: {
				slidesPerView: 2,
				spaceBetween: 0,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 0,
			},
		},
		autoplay: {
			delay: 2500,
			disableOnInteraction: true,
		},
	});

	var swiperOGOGOtestimonials = new Swiper('.acf-block-ogog-testimonials .swiper-container', {
		slidesPerView: 1,
		spaceBetween: 15,
		loop: false,
		grabCursor: true,
		draggable: true,
		// init: false,

		pagination: {
			el: '.swiper-pagination',
			type: 'fraction',
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		breakpoints: {
			640: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			768: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
		},
		autoplay: {
			delay: 2500,
			disableOnInteraction: true,
		},
	});

	var swiperTemplatePart = new Swiper('.custom-template-part-swiper.swiper-container', {
		slidesPerView: 1,
		spaceBetween: 30,
		loop: true,
		grabCursor: true,
		draggable: true,
		// init: false,
		pagination: {
			el: '.swiper-pagination',
			type: 'fraction',
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		breakpoints: {
			640: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			768: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
		},
		autoplay: {
			delay: 2500,
			disableOnInteraction: true,
		},
		on: {
			init: function () {
				for (const key in Object.keys(this.slides)) {
					if (this.slides[key]) {
						const slide = this.slides[key];
						slide.style.cursor = 'pointer';
						slide.addEventListener('click', (e) => {
							if (!(e.target instanceof HTMLAnchorElement)) {
								e.preventDefault();
								const link = slide.querySelector('.card-section a');
								const uri = link.href;
								const target = link.target == '' ? '_self' : '_blank';
								window.open(uri, target);
							}
						});
					}
				}
			},
		},
	});

	var swiperUnlockTimeline = new Swiper('.unlock-timeline-swiper', {
		slidesPerView: 'auto',
		spaceBetween: 15,
		// init: false,
		// pagination: {
		// 	el: '.timeline-pagination.swiper-pagination',
		// 	type: 'fraction',
		// },
		freeMode: true,
		grabCursor: true,
		draggable: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	});

	var swiperUnlockTimeline2021 = new Swiper('.unlock-timeline__swiper-container', {
		slidesPerView: 'auto',
		freeMode: true,
		grabCursor: true,
		draggable: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	});

	var swiperUnlockTeam = new Swiper('.unlock-team__swiper-container', {
		slidesPerView: '1',
		spaceBetween: 15,
		pagination: {
			el: '.swiper-pagination',
			type: 'fraction',
		},
		grabCursor: true,
		draggable: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		breakpoints: {
			600: {
				slidesPerView: 2,
			},
			782: {
				slidesPerView: 3,
			},
		},
	});

	var projectSwiper = new Swiper('.acf-block-swiper-projects .swiper-container', {
		loop: true,
		slidesPerView: 'auto',
		centeredSlides: true,
		spaceBetween: 30,
		grabCursor: true,
		draggable: true,
		pagination: {
			el: '.swiper-pagination',
			type: 'fraction',
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		speed: 1400,
		autoplay: {
			delay: 4000,
			disableOnInteraction: true,
		},
	});

	var homeSwiper = new Swiper('.home-swiper', {
		grabCursor: false,
		draggable: false,
		speed: 1400,
		pagination: {
			el: '.swiper-pagination-home',
			type: 'bullets',
			clickable: true,
		},
		autoplay: {
			delay: 5000,
			disableOnInteraction: true,
		},
	});

	var orgaSwiper = new Swiper('.acf-block-organigramm .swiper-container', {
		grabCursor: false,
		draggable: false,
		speed: 1400,
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		simulateTouch: false,
		keyboard: {
			enabled: true,
		},
	});
	//Organigramm Navigation
	$('.orga-back').click(function () {
		orgaSwiper.slidePrev();
	});
	$('.wikimedia-bubbles-close').click(function () {
		orgaSwiper.slideTo(0, 1000);
	});
	$('.start-slide .wikimedia-bubble').click(function () {
		orgaSwiper.slideTo(1, 1000);
	});
	$('.wikimedia-chapters-slide .wikimedia-bubble').click(function () {
		orgaSwiper.slideTo(1, 1000);
	});
	$('.wikimedia-foundation-slide .wikimedia-bubble').click(function () {
		orgaSwiper.slideTo(1, 1000);
	});
	$('.programme-parent').click(function () {
		orgaSwiper.slideTo(2, 0);
	});
	$('.vorstand-parent').click(function () {
		orgaSwiper.slideTo(3, 0);
	});
	$('.zentrale-dienste-parent').click(function () {
		orgaSwiper.slideTo(4, 0);
	});
	$('.software-entwicklung-parent').click(function () {
		orgaSwiper.slideTo(5, 0);
	});
	$('.praesidium-parent').click(function () {
		orgaSwiper.slideTo(6, 0);
	});
	$('.foundation-bubble').click(function () {
		orgaSwiper.slideTo(7, 1000);
	});
	$('.chapters-bubble').click(function () {
		orgaSwiper.slideTo(8, 1000);
	});

	// Change Logo on scroll
	$(window).scroll(function () {
		if ($(this).scrollTop() > 0) {
			$('.site-header.desktop .logo-container-visibility').fadeOut();
		} else {
			$('.site-header.desktop .logo-container-visibility').fadeIn();
		}
	});

	// Masonry Grid for Calendar Photo view
	var container = document.querySelector('#block-grid');
	if (container) {
		var msnry = new Masonry(container, {
			itemSelector: '#block-grid .cell',
		});
	}

	// Muuri Grid for projects and team
	if ($('.muuri-grid').length > 0) {
		//$('.muuri-grid item').css('position', 'absolute');
		var muuriGrid = new Muuri('.muuri-grid', {
			layout: {
				rounding: false,
			},
		});
		$('.muuri-filters li > a').each(function () {
			var f = $(this).attr('data-muuri-filter');
			var filter;
			if (f) {
				filter = '[data-cat~="' + f + '"]';
			} else {
				filter = '.item';
			}
			$(this).on('click', function () {
				$('.muuri-filters li > a').removeClass('active');
				$(this).addClass('active');
				muuriGrid.filter(filter);
				return false;
			});
		});
	}

	// Animate top illustration
	makeIlluScrollable('.video-container');
	makeIlluAutoScroll('.video-container', true);

	// Focus on search input
	// $('.search-button').click(function(){
	// 	$('#search-input').focus();
	// });

	// Foundation hide scroll nav from: https://foundation.zurb.com/building-blocks/blocks/scrollhide-nav.html
	var prev = 0;
	var $window = $(window);
	var nav = $('.scrollhide-nav');

	$window.on('scroll', function () {
		var scrollTop = $window.scrollTop();
		nav.toggleClass('hidden', scrollTop > prev);
		prev = scrollTop;
	});

	// Fix some blog entries (some texts with no <p> tags...)
	if (location.hostname.startsWith('blog.') && $('[id^="attachment"]').length > 0) {
		$('.content-page')
			.html()
			.match(/<\/div>\s?([^<]|<i>)/g)
			.forEach((s) => {
				$('.content-page').html(
					$('.content-page')
						.html()
						.replace(s, '</div><p>' + s.replace('</div>', ''))
				);
			});
	}
	// Simple go back in history
	function goBack() {
		window.history.back();
	}
	//Plyr Video Player
	// Change the second argument to your options:
	// https://github.com/sampotts/plyr/#options
	const Mobileplayer = new Plyr('.mobile-plyr-custom-player', { captions: { active: false } });
	const player = new Plyr('.plyr-custom-player', { captions: { active: false } });
	$('.close-button').on('click', function () {
		player.stop();
	});
	$('.start-video').on('click', function () {
		player.play();
	});
	// Expose player so it can be used from the console
	window.player = player;
});

$(window).on('load', function () {
	window.dispatchEvent(new Event('resize'));
});

/* Navigation */
$(window).scroll(function () {
	var height = $(window).scrollTop();

	if (height >= 60) {
		$('.header-layer-2').addClass('fixed');
	} else {
		$('.header-layer-2').removeClass('fixed');
	}

	if (height >= 400) {
		$('.header-layer-2-1').addClass('moveup');
	} else {
		$('.header-layer-2-1').removeClass('moveup');
	}

	if (height >= 400) {
		$('.header-layer-2-2').addClass('moveup');
	} else {
		$('.header-layer-2-2').removeClass('moveup');
	}

	if (height >= 400) {
		$('.timeline-year-slider').addClass('moveup');
	} else {
		$('.timeline-year-slider').removeClass('moveup');
	}

	// Mobile
	if (height >= 0) {
		$('.mobile-header-layer-1').addClass('fixed');
	} else {
		$('.mobile-header-layer-1').removeClass('fixed');
	}

	if (height >= 200) {
		$('.mobile-header-layer-1-1').addClass('mobile-moveup');
	} else {
		$('.mobile-header-layer-1-1').removeClass('mobile-moveup');
	}

	if (height >= 200) {
		$('.mobile-header-layer-1-2').addClass('mobile-moveup');
	} else {
		$('.mobile-header-layer-1-2').removeClass('mobile-moveup');
	}

	if (height >= 200) {
		$('.timeline-year-slider').addClass('mobile-moveup');
	} else {
		$('.timeline-year-slider').removeClass('mobile-moveup');
	}
});

/*
 * Make clicking an element trigger a click on the link inside of it (e.g. cards)
 */

document.body.addEventListener('click', function(e) {
  const nestedLinkParentElement = e.target.closest('.clickable');

  if (nestedLinkParentElement && e.target.tagName !== 'A') {
	const nestedLinkElement = nestedLinkParentElement.querySelector('a.permalink');
	const selection = window.getSelection().toString(); // Contains content when user is selecting/highlighting text

	if (!nestedLinkElement || selection) {
	  return;
	}

	e.preventDefault();
	nestedLinkElement.click();
  }
});
